export * from './birth-animal-table/birth-animal-table.component';
export * from './birth-housing-table.component';
export * from './birth-mating-table.component';
